import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export function Footer() {
  const location = useLocation();
  // Function to handle navigation clicks with smooth scrolling
  const handleNavClick = sectionId => {
    // Prevent default anchor behavior
    event.preventDefault();
    // Get the target element to scroll to
    const targetElement = document.getElementById(sectionId);
    if (targetElement) {
      // Scroll smoothly to the element
      targetElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
      // Update URL without page reload
      history.pushState(null, null, `#${sectionId}`);
    }
  };
  return <footer className="bg-navy-900 text-white" data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-145">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-146">
          <div data-id="element-147">
            <h3 className="text-2xl font-bold" data-id="element-148">Upscend Media</h3>
            <p className="mt-4 text-gray-300 max-w-md" data-id="element-149">
              Specialized Facebook ad campaigns that bring qualified leads to
              businesses. We help you grow your business with digital marketing
              that works.
            </p>
          </div>
          <div data-id="element-150">
            <h3 className="text-lg font-bold mb-4 border-b border-navy-800 pb-2" data-id="element-151">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-152">
              <li data-id="element-153">
                {location.pathname === '/' ? <a href="#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={e => {
                e.preventDefault();
                handleNavClick('services');
              }} data-id="element-154">
                    Facebook Ad Campaigns
                  </a> : <Link to="/#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-155">
                    Facebook Ad Campaigns
                  </Link>}
              </li>
              <li data-id="element-156">
                {location.pathname === '/' ? <a href="#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={e => {
                e.preventDefault();
                handleNavClick('services');
              }} data-id="element-157">
                    Lead Generation
                  </a> : <Link to="/#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-158">
                    Lead Generation
                  </Link>}
              </li>
              <li data-id="element-159">
                {location.pathname === '/' ? <a href="#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={e => {
                e.preventDefault();
                handleNavClick('services');
              }} data-id="element-160">
                    Campaign Optimization
                  </a> : <Link to="/#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-161">
                    Campaign Optimization
                  </Link>}
              </li>
              <li data-id="element-162">
                {location.pathname === '/' ? <a href="#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={e => {
                e.preventDefault();
                handleNavClick('services');
              }} data-id="element-163">
                    Ad Creative Design
                  </a> : <Link to="/#services" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-164">
                    Ad Creative Design
                  </Link>}
              </li>
            </ul>
          </div>
          <div data-id="element-165">
            <h3 className="text-lg font-bold mb-4 border-b border-navy-800 pb-2" data-id="element-166">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-167">
              <li data-id="element-168">
                <Link to="/" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-169">
                  Home
                </Link>
              </li>
              <li data-id="element-170">
                {location.pathname === '/' ? <a href="#why-us" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={e => {
                e.preventDefault();
                handleNavClick('why-us');
              }} data-id="element-171">
                    Why Choose Us
                  </a> : <Link to="/#why-us" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-172">
                    Why Choose Us
                  </Link>}
              </li>
              <li data-id="element-173">
                <Link to="/faq" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={() => window.scrollTo(0, 0)} data-id="element-174">
                  FAQ
                </Link>
              </li>
              <li data-id="element-175">
                {location.pathname === '/' ? <a href="#contact" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" onClick={e => {
                e.preventDefault();
                handleNavClick('contact');
              }} data-id="element-176">
                    Contact Us
                  </a> : <Link to="/#contact" className="text-gray-300 hover:text-white transition-all duration-300 hover:translate-x-1 inline-block" data-id="element-177">
                    Contact Us
                  </Link>}
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-navy-800" data-id="element-178">
          <div className="flex justify-center" data-id="element-179">
            <p className="text-gray-400 text-sm" data-id="element-180">
              &copy; {new Date().getFullYear()} Upscend Media. All rights
              reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>;
}